import { _ as _defineProperty, a as _objectWithoutProperties, c as classNames } from './_chunks/dep-03138308.js';
import { createElement, forwardRef, useEffect } from 'react';
import useSizeProps from './util/use-size-props.js';
import { loadStylesheet } from './util/check-url-and-load.js';
import './util/use-common-classname.js';
import './util/use-config.js';
import './util/config-context.js';

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

var _excluded = ["strokeColor", "strokeWidth", "fillColor"],
  _excluded2 = ["icon", "id", "className", "size", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function render(node, id, rootProps) {
  var _strokeColor$, _fillColor$;
  var _rootProps$strokeColo = rootProps.strokeColor,
    strokeColor = _rootProps$strokeColo === void 0 ? "currentColor" : _rootProps$strokeColo,
    _rootProps$strokeWidt = rootProps.strokeWidth,
    strokeWidth = _rootProps$strokeWidt === void 0 ? 2 : _rootProps$strokeWidt,
    _rootProps$fillColor = rootProps.fillColor,
    fillColor = _rootProps$fillColor === void 0 ? "transparent" : _rootProps$fillColor,
    resetRootProps = _objectWithoutProperties(rootProps, _excluded);
  var filledColor;
  if (!rootProps.fillColor) filledColor = "currentColor";else filledColor = Array.isArray(fillColor) ? fillColor[0] : fillColor;
  var childProps = {
    strokeWidth: strokeWidth,
    strokeColor1: Array.isArray(strokeColor) ? strokeColor[0] : strokeColor,
    strokeColor2: Array.isArray(strokeColor) ? (_strokeColor$ = strokeColor[1]) !== null && _strokeColor$ !== void 0 ? _strokeColor$ : strokeColor[0] : strokeColor,
    fillColor1: Array.isArray(fillColor) ? fillColor[0] : fillColor,
    fillColor2: Array.isArray(fillColor) ? (_fillColor$ = fillColor[1]) !== null && _fillColor$ !== void 0 ? _fillColor$ : fillColor[0] : fillColor,
    filledColor: filledColor
  };
  return /*#__PURE__*/createElement(node.tag, _objectSpread(_objectSpread({
    key: id
  }, node.attrs), resetRootProps), (node.children || []).map(function (child, index) {
    return childRender(child, childProps, index);
  }));
}
function childRender(node, childProps, index) {
  var processedAttrs = {};
  if (node.attrs) {
    for (var _i = 0, _Object$entries = Object.entries(node.attrs); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (typeof value === "string" && value.startsWith("props.")) {
        var propName = value.split(".")[1];
        processedAttrs[key] = childProps[propName];
      } else {
        processedAttrs[key] = value;
      }
    }
  }
  return /*#__PURE__*/createElement(node.tag, _objectSpread({
    key: index
  }, processedAttrs), (node.children || []).map(function (child, index2) {
    return childRender(child, childProps, index2);
  }));
}
var IconBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
    id = props.id,
    className = props.className,
    size = props.size,
    style = props.style,
    restProps = _objectWithoutProperties(props, _excluded2);
  var _useSizeProps = useSizeProps(size),
    sizeClassName = _useSizeProps.className,
    sizeStyle = _useSizeProps.style;
  var cls = classNames("t-icon", "t-icon-".concat(id), className, sizeClassName);
  useEffect(function () {
    loadStylesheet();
  }, []);
  return render(icon, "".concat(id), _objectSpread({
    ref: ref,
    className: cls,
    style: _objectSpread(_objectSpread({
      fill: "none"
    }, style), sizeStyle)
  }, restProps));
});

export { IconBase };
//# sourceMappingURL=icon.js.map
